import { BaseOptionType } from 'antd/es/select';

interface RenderOptionProps {
  option: BaseOptionType;
}

const RenderOption: React.FC<RenderOptionProps> = ({ option }) => (
  <div className="mselect-option-item">
    <span>{option.data.label}</span>
  </div>
);

export default RenderOption;
